// extracted by mini-css-extract-plugin
export default {"uploadForm":"InputFile_uploadForm__xrmyi","inputDisabled":"InputFile_inputDisabled__u5RP0","inputFile":"InputFile_inputFile__Q41eL"};